import type React from 'react';
import { useLayoutEffect } from 'react';
import { type BrowserNavigation, GAME_HOME_URL, windowNavigation } from '../../navigation';

export interface SignedInRedirectProps {
  /** How the page leaves. Defaults to the window's location. */
  navigation?: BrowserNavigation;
}

/**
 * /signed-in: kept so old links and history entries still work. Shows nothing, and replaces the location with the
 * game's home before the first paint.
 */
export const SignedInRedirect: React.FC<SignedInRedirectProps> = ({ navigation = windowNavigation }) => {
  useLayoutEffect(() => navigation.replace(GAME_HOME_URL), [navigation]);
  return null;
};
